// const stage = process.env.REACT_APP_STAGE?process.env.REACT_APP_STAGE:'dev';

// Use window element to set the environment and useRecaptcha value
const stage = window.ENV ? (window.ENV.environment ? window.ENV.environment : 'dev') : 'dev'
let useRecaptcha = window.ENV ? window.ENV.useRecaptcha : true
console.log('stage: ', stage)
console.log('useRecaptcha: ', useRecaptcha)

let config = null;
let urlConfig=[{
    domainId:"rauction",
    redirectUrl:"/rauction/redirect"
},
{
    domainId:"rfxmgr",
    redirectUrl:"/rfxmgr/redirect"
},
{
    domainId:"rcontracts",
    redirectUrl:"/rcontracts/redirect"    
},
{
    domainId:"adminui",
    redirectUrl:"/adminui/login"    
}]

const local = {
    API_BASE_URL: "https://localhost:5001/pnc/security/api",
    API_LOGIN: "/v1/auth/login",
    API_FACE: "/v1/auth/face",
    API_OTP_LOGIN: "/v1/auth/otp",
    API_REGISTER: "/v1/auth/register",
    API_RESETPASSWORD: "/v1/auth/rp",
    LOGIN_REDIRECT_URL: "https://pncplatformdev.ril.com",

    API_CHANGEPASSWORD: "/v1/auth/setpassword",
    VALIDATE_TOKEN: "/v1/auth/resetpassword/",
    LOGINURL_AFTERRESET: "/security/login",
    REDIRECT_URL:urlConfig,
    RECAPTCHA_KEY:"6LddQLoUAAAAADhqriuSW7TMNWFoJj9-2krWHIO5",
    useRecaptcha:useRecaptcha
  }; 
const dev = {
    API_BASE_URL: "/pnc/security/api",
    API_LOGIN: "/v1/auth/newLogin",
    API_FACE: "/v1/auth/face",
    API_OTP_LOGIN: "/v1/auth/otp",
    API_REGISTER: "/v1/auth/register",
    API_RESETPASSWORD: "/v1/auth/rp",
    LOGIN_REDIRECT_URL: "/redirect",
    API_CHANGEPASSWORD: "/v1/auth/setpassword",
    VALIDATE_TOKEN: "/v1/auth/resetpassword/",
    LOGINURL_AFTERRESET: "/security/login",
    REDIRECT_URL:urlConfig,
    RECAPTCHA_KEY:"6LddQLoUAAAAADhqriuSW7TMNWFoJj9-2krWHIO5",
    useRecaptcha:useRecaptcha,
    newLogin:'https://pncplatformdev.ril.com/pnc/security/api/v1/auth/newLogin',
    partialLogin:'https://pncplatformdev.ril.com/pnc/security/api/v1/auth/verifyPartialLogin',
    validateOtp:'https://pncplatformdev.ril.com/pnc/security/api/v1/auth/validateOTPAndLogin'
  };  
const test = {
    API_BASE_URL: "/pnc/security/api",
    API_LOGIN: "/v1/auth/newLogin",
    API_FACE: "/v1/auth/face",
    API_OTP_LOGIN: "/v1/auth/otp",
    API_REGISTER: "/v1/auth/register",
    API_RESETPASSWORD: "/v1/auth/rp",
    LOGIN_REDIRECT_URL: "/redirect",
    API_CHANGEPASSWORD: "/v1/auth/setpassword",
    VALIDATE_TOKEN: "/v1/auth/resetpassword/",
    LOGINURL_AFTERRESET: "/security/login",
    REDIRECT_URL:urlConfig,
    RECAPTCHA_KEY:"6LddQLoUAAAAADhqriuSW7TMNWFoJj9-2krWHIO5",
    useRecaptcha:useRecaptcha,
    newLogin:'https://pncplatformqa.ril.com/pnc/security/api/v1/auth/newLogin',
    partialLogin:'https://pncplatformqa.ril.com/pnc/security/api/v1/auth/verifyPartialLogin',
    validateOtp:'https://pncplatformqa.ril.com/pnc/security/api/v1/auth/validateOTPAndLogin'
  };
  const replica = {
    API_BASE_URL: "/pnc/security/api",
    API_LOGIN: "/v1/auth/newLogin",
    API_FACE: "/v1/auth/face",
    API_OTP_LOGIN: "/v1/auth/otp",
    API_REGISTER: "/v1/auth/register",
    API_RESETPASSWORD: "/v1/auth/rp",
    LOGIN_REDIRECT_URL: "/redirect",
    API_CHANGEPASSWORD: "/v1/auth/setpassword",
    VALIDATE_TOKEN: "/v1/auth/resetpassword/",
    LOGINURL_AFTERRESET: "/security/login",
    REDIRECT_URL:urlConfig,
    RECAPTCHA_KEY:"6LddQLoUAAAAADhqriuSW7TMNWFoJj9-2krWHIO5",
    useRecaptcha:useRecaptcha,
    newLogin:'https://pncplatformppd.ril.com/pnc/security/api/v1/auth/newLogin',
    partialLogin:'https://pncplatformppd.ril.com/pnc/security/api/v1/auth/verifyPartialLogin',
    validateOtp:'https://pncplatformppd.ril.com/pnc/security/api/v1/auth/validateOTPAndLogin'
  };
const prod = {
    API_BASE_URL: "/pnc/security/api",
    API_LOGIN: "/v1/auth/newLogin",
    API_FACE: "/v1/auth/face",
    API_OTP_LOGIN: "/v1/auth/otp",
    API_REGISTER: "/v1/auth/register",
    API_RESETPASSWORD: "/v1/auth/rp",
    LOGIN_REDIRECT_URL: "/redirect",
    API_CHANGEPASSWORD: "/v1/auth/setpassword",
    VALIDATE_TOKEN: "/v1/auth/resetpassword/",
    LOGINURL_AFTERRESET: "/security/login",
    REDIRECT_URL:urlConfig,
    RECAPTCHA_KEY:"6LddQLoUAAAAADhqriuSW7TMNWFoJj9-2krWHIO5",
    useRecaptcha:useRecaptcha,
    newLogin:'https://pncplatform.ril.com/pnc/security/api/v1/auth/newLogin',
    partialLogin:'https://pncplatform.ril.com/pnc/security/api/v1/auth/verifyPartialLogin',
    validateOtp:'https://pncplatform.ril.com/pnc/security/api/v1/auth/validateOTPAndLogin'
  };
  


switch (stage) {
    case 'production':
    case 'prod':
        config = prod;
        break;
    case 'replica':
    case 'preprod':
        config = replica;
        break;
    case 'staging':
    case 'stage':
    case 'test':
    case 'qa':
        config = test;
        break;
    case 'dev':
    case 'development':
        config = dev;
        break;
    default:
        config = local;
        break;
}
  export default {
    // Add common config values here
    ...config
  };


// WEBPACK FOOTER //
// ./src/config.js